import React from 'react';

const CheckOut = () => {
    return (<div>
        <div className='w-75 mx-auto bg-info bg-gradient p-3 border border-3 border-dark rounded-3 my-3'>
            <h2 className='bg-dark text-white text-center p-3 rounded'>Check Out Form</h2>
            <form action="" >
                <div className='row row-cols-lg-2 row-cols-md-2 row-cols-1 g-4'>

                    <div className="col">
                        <label for="validationDefault01" className="form-label text-black fs-3 fw-bolder">First name:</label>
                        <input type="text" className="form-control" id="validationDefault01" placeholder="Dhananjoy" required />
                    </div>
                    <div className="col">
                        <label for="validationDefault01" className=" form-label text-black fs-3 fw-bolder">Last name:</label>
                        <input type="text" className="form-control" id="validationDefault01" placeholder="Das" required />
                    </div>
                    <div className="col">
                        <label for="validationDefault01" className=" form-label text-black fs-3 fw-bolder">Email:</label>
                        <input type="email" className="form-control" id="validationDefault01" placeholder="dhananjoychandradas@gmail.com" required />
                    </div>
                    <div className="col">
                        <label for="validationDefault01" className=" form-label text-black fs-3 fw-bolder">Phone:</label>
                        <input type="tel" className="form-control" id="validationDefault01" placeholder="016xxxxxxxx" required />
                    </div>

                    <div className="col">
                        <label for="validationDefault01" className=" form-label text-black fs-3 fw-bolder"> What's your opinion?</label>
                        <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                    </div>

                </div>
                <div className='my-3'>
                    <input class="btn-success rounded-pill p-3 shadow" type="submit" value="Booking" />
                    <input class="btn-danger rounded-pill p-3 ms-3 shadow" type="reset" value="Cancel" />
                </div>
            </form>
        </div>
    </div>
    );
};

export default CheckOut;


